import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { inOutAnimation } from '../../../animations';
import { RecalculateData } from '../model/recalculate-data';
import { CalculatorResultWrapper } from '../../../models/analysis/calculator-result-wrapper';
import { AnalysisService, ConsumptionType, ProductionType } from '../../../../services/analysis.service';
import { LoaderService } from '../../../../services/loader.service';
import { SolarCalculatorRequest } from '../../../models/analysis/solar-calculator-request';
import { PowerPlant } from '../model/power-plant';
import { DialogService } from '../../../../services/dialog/dialog.service';
import { TranslocoService } from '@ngneat/transloco';

@Component({
  selector: 'psc-advanced-solar-calculation-result',
  templateUrl: './advanced-solar-calculation-result.component.html',
  animations: [inOutAnimation({})],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AdvancedSolarCalculationResultComponent {
  private _solarCalculatorResultWrapper: CalculatorResultWrapper;
  get solarCalculatorResultWrapper(): CalculatorResultWrapper {
    return this._solarCalculatorResultWrapper;
  }

  @Input()
  set solarCalculatorResultWrapper(value: CalculatorResultWrapper) {
    this._solarCalculatorResultWrapper = value;
  }
  @Input() showRecalculate: boolean = true;
  @Input() showSavePlant: boolean = true;
  @Input() powerPlant: PowerPlant;

  @Output() recalculated: EventEmitter<CalculatorResultWrapper> = new EventEmitter<CalculatorResultWrapper>();

  get isHourlyManual(): boolean {
    return this.solarCalculatorResultWrapper.consumptionInputMethod === ConsumptionType.HOURLY &&
      (this.solarCalculatorResultWrapper.productionType === ProductionType.NREL ||
        this.solarCalculatorResultWrapper.productionType === ProductionType.PVGIS);
  }

  ConsumptionType: typeof ConsumptionType = ConsumptionType;
  ProductionType: typeof ProductionType = ProductionType;

  constructor(
    private analysisService: AnalysisService,
    private loadingService: LoaderService,
    private dialogService: DialogService,
    private translocoService: TranslocoService,
  ) {
  }

  recalculate(recalculateData: RecalculateData) {

    const request = this._solarCalculatorResultWrapper.request as SolarCalculatorRequest;
    request.reCalculation = recalculateData;
    this.loadingService.showLoader();
    this.analysisService.getAdvancedAnalysis(request, this._solarCalculatorResultWrapper.productionType, this._solarCalculatorResultWrapper.consumptionInputMethod, true).subscribe(
      (resultWrapper) => {
        this._solarCalculatorResultWrapper = resultWrapper;
        this.recalculated.emit(resultWrapper);
      },
    ).add(() => {
      this.loadingService.hideLoader();
    });
  }

}
